<template>
<div>
<div class="">
  <div class="">

      <div name="mapsSearch" class="ui form">

        <div class="row">
          <div style="display: flex;">

            <div class="col-sm-24 searchform" style="width: fit-content; margin:auto;">
              <div style="display: inline;">
              <div class="ui icon input searchmask" style="float:left;margin:6px;">
                <google-autocomplete id="places" v-bind:prevalue="prevalue" classname="['ui','input']"  types="(regions)" v-bind:placeholder="$t('Suche nach PLZ, Ort')" v-on:placechanged="setAddressData">
                </google-autocomplete>
                <i class="map marker icon"></i>
              </div>
              <div class="full" style="float:left; margin:6px;">
                <select v-bind:class="['ui','fluid','dropdown',{'disabled': !address},'full']" v-model="filter" :disabled="!address"  @change="filterResults()" id="filter"><option value="">{{$t('Alle')}}</option>
                <option value="0">{{$t('Alle')}}</option>
                <option value="1">{{$t('Vermieter')}}</option>
                <option value="2">{{$t('Verkauf')}}</option>
                <option value="3">{{$t('Servicepartner')}}</option>
                </select>
              </div>
            </div>

              <!--
              <div v-bind:class="['ui', 'red', 'button', {'disabled':dealer.length <= 0},'searchresultbtn']" style="width: 100%; max-width: 200px; font-size: 1.2em;" @click="showList()">
              {{$t('Händler suchen')}} <i class="right arrow icon"></i>
              </div>
            -->
            </div>

          </div>
        </div>

        <br>


        <div class="ui divider"></div>
        <br><br>
      </div>
  </div>

  <div class="">
      <div class="">
        <div class="col-xs-24 col-sm-12">
            <dealer-list-view v-for="(d,index) in dealer" :index="index" :dealer="d" :ref="'dv'+index"></dealer-list-view>
            <br>
            <div class="col-md-24 col-sm-24 col-xs-24 nopadding">
              <button v-if="dealer.length > 0 && dealer.length < 10" class="ui basic button red" @click="loadMore()">Mehr Laden</button>
            </div>
            <br>
            <br>
        </div>
        <div class="col-xs-24 col-sm-12">
          <GmapMap v-if="dealer && dealer.length>0"
    :center=center
    :zoom="getZoom()"
    :draggable="false"
    style="width: 100%; height: 600px"
  >
  <GmapMarker
    :key="index"
    v-for="(m, index) in dealer"
    :position="{lat: parseFloat(m.lat), lng: parseFloat(m.lng)}"
    :clickable="true"
    :draggable="false"
    :label=  "hh"
    :icon = "markerOptions"
    @click="onmMarkerClicked(index)"
  />
  </GmapMap>
    </google-map>

        </div>
      </div>
  </div>
</div>

</div>
</template>

<script>

const mapMarker = require('../assets/mapmarker.svg');

import Config from '../Config';
import {
  mapState,
  mapActions
} from 'vuex'
import {
  formatDateOnly
} from '../utils/DateFormatter.js'
import GoogleAutocomplete from './sections/GoogleAutoComplete'
import DealerListView from './sections/DealerListView'
import VueScrollTo from 'vue-scrollto';
import GmapCustomMarker from 'vue2-gmap-custom-marker';

export default {
  name: 'Search',
  props: {},
  data: function() {
    return {
      searching: false,
      mdistance: 0,
      mcountry: "DE",
      prevalue: '',
      filter: 0,
      limit: 5,
      center: {},
      markerOptions: {
        url: mapMarker,
        size: {width: 60, height: 90, f: 'px', b: 'px',},
        scaledSize: {width: 30, height: 45, f: 'px', b: 'px',},
   }
    }
  },
  components: {
    GoogleAutocomplete,
    DealerListView,
    'gmap-custom-marker': GmapCustomMarker
  },
  computed: {

    dealer() {
      return this.$store.state.summery.dealer;
    },
    address() {
      return this.$store.state.summery.address;
    }
  },

  created() {


  },
  methods: {
    setAddressData: function(addressData, placeResultData, id) {
      this.limit = 5;
      this.$store.commit('summery/address', addressData);
      this.getAvailableDealer(this.address.latitude,this.address.longitude, this.limit, this.filter);
    },
    setMapCenter: function(){

    },
    getZoom: function(){

      let maxDistance = this.dealer[this.dealer.length-1].distance;
      let zoom = 9;

      if(maxDistance > 100) zoom = 8;
      if(maxDistance > 150) zoom = 7;
      if(maxDistance > 500) zoom = 6;
      console.log(maxDistance);


      return zoom;
    },
    loadMore: function(){
      this.limit = 10;
      this.filterResults(this.filter);
    },
    onmMarkerClicked: function(index){

      for(let i in this.dealer){
        //  this.$refs[`dv`+i][0].deactivate()
      }

      VueScrollTo.scrollTo('#dealerview-'+index,1000,{offset:-114});
      this.$refs[`dv`+index][0].activate();

      //this.center = {lat: parseFloat(this.dealer[index].lat), lng:parseFloat(this.dealer[index].lng)}
    },
    filterResults: function(id){
      this.$store.commit('summery/filter', id);
      this.getAvailableDealer(this.address.latitude,this.address.longitude, this.limit, this.filter);
    },
    getAvailableDealer: function(lat,lng,limit, filter){
      this.searching = true;

      this.$store.dispatch('summery/dealerByLocation', {
        lat: lat,
        lng: lng,
        limit: limit,
        filter: filter
      }).then((count) => {
        this.searching = false;
        this.center = {lat: parseFloat(this.dealer[0].lat), lng:parseFloat(this.dealer[0].lng)}
      })
    },
    clearAdressInput: function(){
      //this.prevalue = '';
    }
  }

}
</script>

<style scoped>


.step{
  background-color: rgb(238, 238, 238);
  display: inline;
  padding:10px;
  padding-bottom: 14px;
}
.ui.input {
    font-size: 1.2em;
}

.searchmask{
  min-width: 500px;
}

.mcontainer {
  display: inline;;
  position: relative;
  padding-left: 28px;
  margin-bottom: 12px;
  cursor: pointer;
  float: none;
  font-size: 1em;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-right: 10px;
}

.ui.fluid.dropdown {
    display: block;
  width: auto;
    min-width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: -4;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: rgb(248, 248, 248);
}

/* On mouse-over, add a grey background color */
.mcontainer:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.mcontainer input:checked ~ .checkmark {
  background-color: #c51a1b;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.mcontainer input:checked ~ .checkmark:after {
  display: block;
}

/* On mouse-over, add a grey background color */
.mcontainer:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.mcontainer input:checked ~ .checkmark {
  background-color: #c51a1b;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.mcontainer input:checked ~ .checkmark:after {
  display: block;
}


/* Style the checkmark/indicator */
.mcontainer .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

input[type="checkbox"]{
  display: none;
}

input[type="text"]{
  height: 44px;
}

select.ui.dropdown {
    height: 44px;
}
.searchform{
  text-align: center;
}
.searchresultbtn{
  margin-left: 20px;
  margin-top: 10px;
}

.full{
  width: auto;
}

@media only screen and (max-width: 772px) {

  .full{
    width: 100%!important;
  }
  .searchmask{
    min-width: 100%;
  }
}

.ui.input.focus>input, .ui.input>input:focus {
    border-color: #000000;
}

.step{
  margin-bottom: 14px;
}

.textshadow {
  text-shadow: 2px 2px rgba(0,0,0,0.3);
}
.textshadowl {
  text-shadow: 2px 2px rgba(0,0,0,0.1);
}

</style>
